import { ExemptedPartDTO } from 'src/app/models/internal/exemptedpart-dto';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import Helper from 'src/app/core/utility/helper';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormService } from 'src/app/services/form';
import { DataService } from 'src/app/services/data.service';
import { BasePage } from 'src/app/core/basepages/allbasepages';

@Component({
  selector: 'app-pe-exemptpart-reason',
  templateUrl: './pe-exemptpart-reason.component.html',
  styleUrls: ['./pe-exemptpart-reason.component.scss']
})

/*
tms- 33947 Create component to give exemption reason for selected. UI will display pop-up window to give exemption reason for the selected parts 
tms-34674 limit reason size to 255 characters. 
*/

export class PeExemptpartReasonComponent extends BasePage implements OnInit {
  exemptionReasonForm: FormGroup;
  proposalId: string;
  exemptedPendingProposalList: ExemptedPartDTO[];
  public formErrors = {
    ExemptionComment: ''
  };

  constructor(
    private dialogRef: MatDialogRef<PeExemptpartReasonComponent>,
    @Inject(MAT_DIALOG_DATA) private inputexemptedPendingProposalList: ExemptedPartDTO[],
    private fb: FormBuilder,
    private dataService: DataService,
    private FormService: FormService,
    private toastService: ToastService,
    localstorageService: LocalstorageService,
    logger: NGXLogger,
    appSettings: AppSettings

  ) {
    super(localstorageService, logger, appSettings);
    this.exemptionReasonForm = this.fb.group({
      ExemptionComment: [null, Validators.maxLength(255)]
    });
    this.exemptedPendingProposalList = inputexemptedPendingProposalList;
  }

  ngOnInit() {
  }

  ValidateForm() {
    Helper.resetFormErrors(this.formErrors);
    this.formErrors = this.FormService.validateForm(
      <FormGroup>this.exemptionReasonForm,
      this.formErrors
    );
  }

  submit() {
    this.saveExemptionPartWithComment();
    this.dialogRef.close();
  }

  saveExemptionPartWithComment() {
    this.ValidateForm();
    this.prepareModel();
    this.dataService
      .updateExemptedPart(this.exemptedPendingProposalList)
      .subscribe((response: any) => {
        if (response != null && response.Success) {
          this.toastService.success('Part exemption updated successfully');
        } else {
          this.toastService.error(
            'Could not update exemption for the part'
          );
        }
      });
  }

  prepareModel() {
    const exemptionReason = this.exemptionReasonForm.controls['ExemptionComment'].value
    this.exemptedPendingProposalList.filter(x => x.IsExempted == true).forEach(x => x.ExemptionReason = exemptionReason);
  }

}
